import React from 'react';
import './ResearchSnippet.css';

export default function ResearchSnippet({ onNavigate }) {
  return (
    <section className="research-snippet-section">
      <div className="container">
        <div className="research-snippet-card card-tech">
          
          <div className="rs-badge">NEW RESEARCH REPORT • PLAYERMAKER PRO</div>
          
          <h2 className="rs-title">
            Closing the Gap: <span className="highlight-pink">Bilateral Football Mastery</span> in the Modern Game
          </h2>
          
          <p className="rs-desc">
            An extensive analysis of 30,000+ youth soccer player tracking sessions (2023–2026) by Dr. Erez Morag and elite sports scientists. Discover why two-footed players command a 14–15% salary premium and unlock 360° passing vision.
          </p>

          <div className="rs-tags-grid">
            <div className="rs-tag">
              <span className="tag-val pink">16.8%</span>
              <span className="tag-label">Kicking Velocity Gap</span>
            </div>

            <div className="rs-tag">
              <span className="tag-val teal">360°</span>
              <span className="tag-label">Field Passing Vision</span>
            </div>

            <div className="rs-tag">
              <span className="tag-val pink">14–15%</span>
              <span className="tag-label">Ambidexterity Premium</span>
            </div>

            <div className="rs-tag">
              <span className="tag-val teal">Ages 7–14</span>
              <span className="tag-label">Wenger's Technical Basement</span>
            </div>
          </div>

          <div className="rs-cta-wrap">
            <button 
              onClick={() => onNavigate('/bilateral-mastery')} 
              className="rs-btn-primary"
            >
              Explore Interactive Research Paper →
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}
